import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButton from "../../../components/Form/BackButton";
import { API, defaultLimitPagination, fileUpload, get } from "../../../config";
import { toast } from "react-toastify";
import { Modal as BSModal, Button, Modal } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { checkRole } from "../../common/Misc";
import SearchBox from "../../common/SearchBox";
import { debounce } from "lodash";
import Spin from "../../common/Spin";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import { getStatusIcon, getSupportDetail } from "./SupportTicketHelper";
import SupportTicketActionButton from "./SupportTicketActionButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import ProjectSubHeader from "../../Project/components/ProjectSubHeader";
import SupportTicketView from "./SupportTicketView";

const SupportTicket = () => {
  // const navigate = useNavigate();
  const location = useLocation();
  const roleType = localStorage.getItem("roleType");
  const params = useParams();

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const ticketId = query.get("ticketId");
  const navigate = useNavigate();
  
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [supportTicket, setSupportTicket] = useState([]);
  const projectId = params?.project_id;

  const [showSupportUser, setShowSupportUser] = useState(false);

  const [subject, setSubject] = useState();
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [editorState, setEditorState] = useState(null);
  const handleEditorChange = (state) => {
    setEditorState(state);
  };
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isFetchDataLoading, setIsFetchDataLoading] = useState();
  const [reply, setReplay] = useState(false);
  const [showView, setShowView] = useState(false);
  const [supportDetail, setSupportDetail] = useState();

  // const roleType = localStorage.getItem('roleType');

  const fetchData = async () => {
    setIsFetchDataLoading(true);
    const userDetailData = await getSupportDetail(ticketId);
    if (userDetailData?.support_ticket_comments?.length === 1) {
      setReplay(true);
    } else {
      setReplay(false);
    }
    setSupportDetail(userDetailData);
    setIsFetchDataLoading(false);
  };

  const toggleShowModal = () => {
    if (!showView) {
      fetchData();
    } else {
      fetchSupportTickets();
      checkRole(roleType) ? navigate(`/admin/support-tickets`) :
      navigate(`/projects/${projectId}/support-tickets`)
    }
    setShowView(!showView);
  };

  useEffect(() => {
    if (ticketId) {
      toggleShowModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketId]);

  const fetchSupportTickets = useCallback(
    async (passLimit, passPage) => {
      try {
        setIsDataLoading(true);
        const { data } = await get(
          `${
            checkRole(roleType) ? API.ADMIN_SUPPORT_TICKET : API.SUPPORT_TICKET
          }?search=${searchParam}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}${
            checkRole(roleType)
              ? ""
              : "&builder_project_id=" + (projectId ? projectId : "")
          }`
        );
        setIsDataLoading(false);
        const userData = data.data.data;
        setSupportTicket(userData);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
      } catch (e) {
        setSupportTicket([]);
        setIsDataLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam]
  );

  useEffect(() => {
    fetchSupportTickets();
  }, [fetchSupportTickets]);

  // const handleChange = async (value) => {
  //   setLimit(value);
  //   if (checkRole(roleType)) {
  //     navigate(`/admin/support-tickets?page=1&limit=${value}`, {
  //       replace: true,
  //     });
  //   } else {
  //     navigate(`/support-tickets?page=1&limit=${value}`, {
  //       replace: true,
  //     });
  //   }

  //   fetchSupportTickets(1, value);
  // };

  const toggleSupportModal = () => {
    setShowSupportModal(!showSupportModal);
  };
  const toggleSupportUserModal = () => {
    if (!showSupportUser) {
      setSubject();
      setEditorState(null);
      setFiles([]);
    }
    setShowSupportUser(!showSupportUser);
  };

  // const handleFileChange = (info) => {
  //   console.log(info);

  //   setFiles(info.fileList);
  // };

  const handleUpload = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("subject", subject);
    const value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    if (!checkRole(roleType)) {
      formData.append("builder_project_id", projectId ? projectId : "");
    }
    formData.append("message", value);
    files.forEach((file, index) => {
      if (file !== undefined) {
        formData.append(`attachments[${index}]`, file);
      }
    });
    const config = { headers: { "Content-Type": "multipart/form-data" } };
    fileUpload(
      checkRole(roleType) ? API.ADMIN_SUPPORT_TICKET : API.SUPPORT_TICKET,
      formData,
      config
    )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          toast.success(response.data.message);
          fetchSupportTickets();
          toggleSupportModal();
          toggleSupportUserModal();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const { data } = err.response;
        toast.error(data?.message);
        toast.error(
          data.errors &&
            data.errors.customer_file &&
            data.errors.customer_file[0]
        );
        toast.error(
          data.errors && data.errors.myna_error && data.errors.myna_error[0]
        );
        var error = {};
        error["myna_error"] =
          "There is some issue with request, please try after some time.";
      });
  };

  // const fileProps = {
  //   name: "file",
  //   multiple: true,
  //   headers: {
  //     authorization: "authorization-text",
  //   },
  //   accept: "*",
  //   beforeUpload: () => {
  //     return false;
  //   },
  //   onChange(info) {
  //     handleFileChange(info);
  //   },
  // };

  const checkDisable = () => {
    if (subject && editorState?.getCurrentContent()?.hasText()) {
      return false;
    } else {
      return true;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  // const onSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchParam(value);
  //   setPage(1);
  // };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchSupportTickets(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchSupportTickets(limit, page);
  };

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const columns = checkRole(roleType)
    ? [
        {
          text: "ID",
          dataField: "support_ticket_id",
        },
        {
          text: "Project",
          dataField: "project_name",
        },
        {
          text: "Subject",
          dataField: "subject",
        },
        {
          text: "Created By",
          dataField: "created_by",
        },
        // {
        //   text: "Access Given By",
        //   dataField: "access_given_by",
        // },
        // {
        //   text: "Access Given Date",
        //   dataField: "access_given_date",
        // },
        // {
        //   text: "Access Revoke Date",
        //   dataField: "access_revoke_date",
        // },
        {
          text: "Created Date",
          dataField: "created_at",
        },
        {
          text: "Updated Date",
          dataField: "updated_at",
        },
        {
          text: "Status",
          dataField: "status",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
        {
          text: "Action",
          dataField: "action",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
      ]
    : [
        {
          text: "ID",
          dataField: "support_ticket_id",
        },
        {
          text: "Subject",
          dataField: "subject",
        },
        {
          text: "Created By",
          dataField: "created_by",
        },
        // {
        //   text: "Access Given By",
        //   dataField: "access_given_by",
        // },
        // {
        //   text: "Access Given Date",
        //   dataField: "access_given_date",
        // },
        // {
        //   text: "Access Revoke Date",
        //   dataField: "access_revoke_date",
        // },
        {
          text: "Created Date",
          dataField: "created_at",
        },
        {
          text: "Updated Date",
          dataField: "updated_at",
        },
        {
          text: "Status",
          dataField: "status",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
        {
          text: "Action",
          dataField: "action",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
      ];

  const supportTicketGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: supportTicket[i]?.id,
        id: supportTicket[i]?.id ? supportTicket[i]?.id : "",
        support_ticket_id: supportTicket[i]?.support_ticket_id
          ? supportTicket[i]?.support_ticket_id
          : "",
        project_name: supportTicket[i]?.builder_project?.project_name
          ? supportTicket[i]?.builder_project?.project_name
          : "",
        subject: supportTicket[i]?.subject ? supportTicket[i]?.subject : "",
        created_by: supportTicket[i]?.details?.replied_by?.first_name
          ? supportTicket[i]?.details?.replied_by?.first_name +
            " " +
            supportTicket[i]?.details?.replied_by?.last_name
          : supportTicket[i]?.details?.replied_by?.last_name,
        access_given_by: supportTicket[i]?.access_given_date
          ? supportTicket[i]?.access_given_by?.first_name
            ? supportTicket[i]?.access_given_by?.first_name +
              " " +
              supportTicket[i]?.access_given_by?.last_name
            : supportTicket[i]?.access_given_by?.last_name
          : "-",
        access_given_date: supportTicket[i]?.access_given_date
          ? supportTicket[i]?.access_given_date.split("-").reverse().join("-")
          : "-",
        access_revoke_date: supportTicket[i]?.access_revoke_date
          ? supportTicket[i]?.access_revoke_date.split("-").reverse().join("-")
          : "-",
        created_at: supportTicket[i]?.created_at
          ? moment(supportTicket[i]?.created_at, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY hh:mm A"
            )
          : "-",
        updated_at: supportTicket[i]?.updated_at
          ? moment(supportTicket[i]?.updated_at, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY hh:mm A"
            )
          : "-",
        status: supportTicket[i]?.status
          ? getStatusIcon(
              supportTicket[i]?.status,
              supportTicket[i]?.is_resolved
            )
          : "",
        action: (
          <SupportTicketActionButton
            supportDetails={supportTicket[i]}
            data={{ id: supportTicket[i]?.id }}
            id={supportTicket[i]?.id}
            fetchSupportTickets={fetchSupportTickets}
          />
        ),
      });
    }
    return items;
  };

  const supportTickets = supportTicketGenerator(supportTicket?.length);

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
    // if (onUpload) {
    //   onUpload(selectedFiles);
    // }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block admin-list-table">
          {checkRole(roleType) ? (
            <h1 className="page-title">
              <BackButton />
              Support Tickets
            </h1>
          ) : (
            <ProjectSubHeader title={"Support Tickets"} />
          )}
          <div className="content-details">
            <div className="table-top-btn">
              <div className="">
                <SearchBox
                  placeholder={"Search Tickets"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
              </div>
              <div className="table-btn">
                {!checkRole(roleType) && (
                  <Button
                    variant="primary"
                    onClick={() => {
                      toggleSupportUserModal();
                    }}
                  >
                    Add Support Ticket
                  </Button>
                )}
              </div>
            </div>
            {/* <div style={{ width: "100%", height: "85%" }}> */}
            <div className="custom-table">
              {isDataLoading && <Spin />}
              <BootstrapTable
                keyField="roles_id"
                remote
                data={supportTickets}
                columns={columns}
                noDataIndication="No Data Found"
              />
              <Pagination
                total={total}
                limit={parseInt(limit)}
                currentPage={page}
                updateLimit={handleUpdateLimit}
                updatePage={handleChangePage}
                from={from}
                to={to}
              />
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
      {showSupportUser && (
        <BSModal
          show={showSupportUser}
          onHide={toggleSupportUserModal}
          dialogClassName="modal-50w larg-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <BSModal.Header closeButton>Add Support Ticket</BSModal.Header>
          <BSModal.Body>
            <div className="support-ticket support-ticket-framebox">
              <form>
                <div className="support-ticket-field support">
                  <div className="form-box">
                    <div className="form-group full-width">
                      <label>
                        <span className="required">*</span>Subject
                      </label>
                      <input
                        type="text"
                        name={`subject`}
                        value={subject ? subject : ""}
                        onChange={(e) => {
                          setSubject(e?.target?.value);
                        }}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="support-ticket-field">
                  <div className="form-box">
                    <div className="form-group full-width">
                      <label>
                        <span className="required">*</span>Message
                      </label>
                      <Editor
                        editorState={editorState}
                        toolbar={{
                          inline: {
                            options: ["bold", "italic", "underline"],
                          },
                          options: [
                            "inline",
                            "fontSize",
                            "list",
                            "textAlign",
                            "remove",
                            "history",
                          ],
                        }}
                        onEditorStateChange={handleEditorChange}
                        wrapperClassName="wrapper-class"
                        editorClassName="editor-class"
                        toolbarClassName="toolbar-class"
                      />
                    </div>
                  </div>
                </div>

                <div className="support-ticket-field">
                  <div className="upload-div">
                    {/* <Upload {...fileProps}>
                    <BSButton className="reply-btn attachment-btn">
                      {" "}
                      <FontAwesomeIcon icon={faPlus} /> Add Attachment
                    </BSButton>
                  </Upload> */}
                    <div>
                      <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: "none" }}
                      />
                      <Button
                        className="reply-btn attachment-btn"
                        onClick={handleButtonClick}
                      >
                        <FontAwesomeIcon icon={faPlus} /> Add Attachment
                      </Button>
                      {files.length > 0 && (
                        <ul className="ant-upload-list ant-upload-list-text">
                          {files.map((file, index) => (
                            <li
                              key={index}
                              className="ant-upload-list-item ant-upload-list-item-done"
                            >
                              <FontAwesomeIcon
                                icon={faPaperclip}
                                className="attachment-icon"
                              />
                              <span className="ant-upload-list-item-name">
                                {file.name}
                              </span>
                              <FontAwesomeIcon
                                icon={faTrash}
                                className="delete-icon"
                                onClick={() => handleFileDelete(index)}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="modal-footer">
                <Button
                  disabled={isLoading || checkDisable()}
                  onClick={() => toggleSupportModal()}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </Button>
                <Button
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  aria-label="Close"
                  type="Button"
                  onClick={() => toggleSupportUserModal()}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </BSModal.Body>
        </BSModal>
      )}
      {showSupportModal && (
        <Modal
          size="lg"
          show={showSupportModal}
          onHide={toggleSupportModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header className="mb-0" closeButton>
            New Support Ticket
          </Modal.Header>
          <Modal.Body>
            {isLoading && <Spin />}
            <div className="modal-body">
              <p>Are your sure you want to add support ticket?</p>
              <div className="modal-footer">
                <Button onClick={handleUpload} className="btn btn-primary">
                  OK
                </Button>
                <Button
                  className="btn btn-secondary"
                  onClick={toggleSupportModal}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {showView && ticketId && (
        <>
          <SupportTicketView
            showView={showView}
            toggleShowModal={toggleShowModal}
            loading={isFetchDataLoading}
            supportDetail={supportDetail}
            handleDelete={fetchSupportTickets}
            id={ticketId}
            fetchData={fetchData}
            fetchSupportTickets={fetchSupportTickets}
            setReplay={setReplay}
            reply={reply}
          />
        </>
      )}
    </div>
  );
};

export default SupportTicket;
